import {tendenzenMappings, vorhersageMappings} from './txtToJsonMapping.js';
import {api} from './api.js';
import {replaceUmlaute} from './umlaut';

let loaded = {};

const addNewBranch = (data, txtkey, txtval, mapping) => {
  const tree = mapping.jsontree;
  let pos = data;
  try {
    tree.split('.').forEach((key, i, a) => {
      key = key.replace('@', txtkey);

      /**
       ** HERE THE VALUE GETS WRITTEN **
       * last key? write value and break loop
       */
      // #TODO: check for different types in txt file .. always float/numeric?
      if (i === a.length - 1) {
        pos[key] = parseFloat(txtval);
        throw new Error();
      }

      /**
       * check if array
       */
      let arrayIdentifier = key.split('[');
      key = arrayIdentifier[0]; // always available
      arrayIdentifier = arrayIdentifier[1]; // check if null

      /**
       * only parse keys - not array identifiers
       */
      if (!arrayIdentifier) key = key.replace('$', parseInt(txtkey));

      /**
       * add object member
       */
      if (!pos[key]) pos[key] = arrayIdentifier ? [] : {};
      pos = pos[key];

      if (arrayIdentifier !== undefined) {
        // console.log(key + ' is an array');
        if (!Array.isArray(pos)) throw new Error(); // break - dont overwrite existing members

        arrayIdentifier = arrayIdentifier.replace(']', '').split('=');
        if (arrayIdentifier.length < 2) throw new Error(); // break - not enough data
        key = arrayIdentifier[0];
        /**
         * current key is array
         */
        arrayIdentifier = arrayIdentifier[1].replace('$', parseInt(txtkey)); // int is enough, float wont be used for identification

        let shallowcopy = pos.filter(el => el[key] === arrayIdentifier);

        /**
         * check if array value in array
         */
        if (shallowcopy.length) {
          /**
           * shallowcopy has still real references to array members
           */
          pos = pos[0];
        } else {
          /**
           * if not > add new element to array
           */
          pos.push({[key]: arrayIdentifier});
          pos = pos[pos.length - 1];
        }
      }
    });
  } catch {}
  return data;
};

const processLine = (data, line, path) => {
  if (path.indexOf('Vorhersage') !== -1) {
    vorhersageMappings.some(function (mapping) {
      const regex = new RegExp('^' + mapping.prefix + '(.+)="(.+)"', 'gi');
      const match = regex.exec(line);

      if (!match || match.length < 3) return false;

      const txtkey = replaceUmlaute(match[1].toLowerCase());
      const txtval = match[2].toLowerCase();

      //console.log(txtkey)

      data = addNewBranch(data, txtkey, txtval, mapping);

      return true;
    });
  } else {
    tendenzenMappings.some(function (mapping) {
      const regex = new RegExp('^' + mapping.prefix + '(.+)="(.+)"', 'gi');
      const match = regex.exec(line);

      if (!match || match.length < 3) return false;

      //            const txtkey = match[1].toLowerCase();
      const txtkey = replaceUmlaute(match[1].toLowerCase());

      const txtval = match[2].toLowerCase();

      // mapping schreibt alle 15 positionen in die json
      //
      if (match[0].startsWith('TX_')) {
        //  if (index >= 5 && index <=11) {
        data = addNewBranch(data, txtkey, txtval, mapping);
        //  }
      } else {
        data = addNewBranch(data, txtkey, txtval, mapping);
      }

      return true;
    });
  }
  return data;
};

const filterLine = line => {
  if (!line.length) return false;
  if (line.substring(0, 2) === '/*') return false;

  return true;
};

const writeStringDataToObject = (data, str, path) => {
  let lines = str.split('\n');
  lines = lines.filter(filterLine);
  lines.forEach(line => {
    data = processLine(data, line, path);
  });

  return data;
};

/**
 * loads text from current host
 *
 * @param {string} path - url path (added to current host)
 *
 * @return {string} file content as string
 * */
const loadTxtToString = async path => {
  try {
    const response = await fetch(api.files.readTxt(path));
    return response.text();
  } catch (error) {
    console.error(error);
    return '';
  }
};

/**
 * generates object from text file once,
 * data is saved and reused from "loaded"
 * in case textfiles in filesystem change, "reset" has to be called
 *
 * @param {string} path - url path (added to current host)
 *
 * @return {object} object containing member tree specified in "mapping"
 * */
const loadTextIntoData = async (data, path) => {
  if (loaded[path]) return loaded[path];

  const str = await loadTxtToString(path);
  data = writeStringDataToObject(data, str, path);
  loaded[path] = data;

  return data;
};

const reset = () => {
  loaded = {};
};

export {loadTextIntoData, reset};
